<template>
    <div class="pages profile-console" :class="{ mobile: classObj.mobile, isMobileHidePerson, 'pcn-overview': isOverview }">
        <h1 v-if="isOverview" class="pcn-main-title">{{ profileCopy.title }}</h1>
        <section v-if="!isMobileHidePerson" class="pcn-identity">
            <div class="pcn-user">
                <div class="pcn-avatar">
                    <img v-theme-art="$themeImage('person.avatar')" :src="$themeImage('person.avatar')" alt="">
                    <span><AccountIcon name="crown" />VIP {{ userInfo.levelDetailVo?.memberLevelCode ?? '—' }}</span>
                </div>
                <div class="pcn-user-copy">
                    <strong>{{ profileCopy.hello }}<template v-if="userPhone">, {{ userPhone }}</template></strong>
                    <button type="button" class="pcn-copy" :disabled="!userInfo.id" :aria-label="$t('lang.copy') + ' ID'" @click.stop="copyText(userInfo.id)">ID: {{ userInfo.id || '—' }} <AccountIcon name="copy" /></button>
                    <time v-if="classObj.mobile">{{ userInfo.registerTime || '—' }}</time>
                </div>
            </div>
            <div v-if="!classObj.mobile" class="pcn-registered"><span>{{ profileCopy.registered }}</span><strong>{{ userInfo.registerTime || '—' }}</strong></div>
            <div v-if="!classObj.mobile" class="pcn-identity-stat"><span>{{ $t('MyProfile.TotalBet') }}</span><strong>{{ profileMoney(userInfo.grandTotalBetting) }}</strong></div>
            <div v-if="!classObj.mobile" class="pcn-identity-stat"><span>{{ $t('MyProfile.TotalBonus') }}</span><strong>{{ profileMoney(userInfo.grandTotalBouns) }}</strong></div>
        </section>
        <div class="profile-layout">
            <main class="profile-workspace">
                <button v-if="!classObj.mobile && isMobileHidePerson" type="button" class="profile-subpage-back" @click.stop="toPerson"><AccountIcon name="back" /><span>{{ $t('lang.back') }}</span></button>
                <router-view ref="routerView" @logout="handleLogout" @desktop-service="handleDesktopService" />
            </main>
        </div>
        <loginPopup @loginSucc="init"></loginPopup>
        <logoutPopup ref="logoutPopup"></logoutPopup>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { Toast } from 'vant'
import handleCopy from '@/utils/copy.js'
import logoutPopup from '@/components/logoutPopup'
import AccountIcon from './components/accountIcon.vue'
import profileCopy from './components/profile-copy'
export default {
    name: 'Person',
    components: { logoutPopup, AccountIcon },
    mixins: [profileCopy],
    computed: {
        isOverview() { return this.$route.name === 'Person' },
        isLogin() {
            return !!this.$store.getters.token
        },
        userInfo() {
            return this.$store.getters.userInfo
        },
        userPhone() {
            const phone = this.userInfo && this.userInfo.phone
            return phone ? this.maskNumber(phone) : ''
        },
        // userMoney() {
        //     // const userInfo = this.$store.getters.userInfo
        //     const info = {
        //         balanceAmtAccount: this.allBalance
        //         // bonusAmtAccount: userInfo.balanceAmtAccount ? userInfo.bonusAmtAccount.useBalance.toFixed(2) : '0.0'
        //     }
        //     return info
        // },
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            const obj = {
                mobile: this.device === 'mobile'
            }
            // const meta = this.$route.meta
            // console.log(meta, 'meta')
            // if (meta) {
            //     const isMobileHidePerson = meta.isMobileHidePerson
            //     obj.isMobileHidePerson = isMobileHidePerson
            // }
            return obj
        },
        sysConfig() {
            return this.$store.getters.sysConfig
        },
        langType() {
            return this.langObj[this.$store.getters.language].name || 'English'
        },
        invitationPageRewardState() {
            return this.$store.getters.userInfo && this.$store.getters.userInfo.invitationPageRewardState
        }
    },
    data() {
        return {
            menuAct: 'Person',
            isMobileHidePerson: false
        }
    },
    methods: {
        handleDesktopService(action) {
            const handlers = { redemption: this.toRedemptionRecords, transactions: this.toTransaction, history: this.toBetHistory, password: this.toChangePwd, language: this.toLanguage, notifications: this.toNotification, support: this.toServer, install: this.toDownApp }
            if (Object.prototype.hasOwnProperty.call(handlers, action)) handlers[action]()
        },
        init() {
            const that = this
            const child = that.$refs.routerView
            if (that.menuAct === 'Person') child.init()
        },
        maskNumber(phoneNumber) {
            const str = phoneNumber.toString()
            if (str.length <= 4) {
                return str
            }
            const firstTwo = str.slice(0, 2)
            const lastTwo = str.slice(-2)
            return `${firstTwo}***${lastTwo}`
        },
        copyText(content) {
            handleCopy(
                {
                    content,
                    success: (msg) => {
                        Toast(msg)
                    },
                    error: (msg) => {
                        Toast(msg)
                    }
                },
                this
            )
        },
        handleLogout() {
            this.$refs.logoutPopup.open()
        },
        toLogin(type) {
            this.$store.dispatch('user/changeLoginType', type)
            this.$store.dispatch('user/setIsShowLoginPopup', true)
        },
        toDeposit() {
            if (this.$route.path.indexOf('/wallet?type=deposit') !== -1) {
                return
            }
            const params = { type: 'deposit' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        },
        toWithdraw() {
            if (this.$route.path.indexOf('/wallet?type=Withdraw') !== -1) {
                return
            }
            const params = { type: 'Withdraw' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        },
        toBetHistory() {
            this.$router.push('/PersonBox/History')
        },
        toTransaction() {
            this.$router.push('/PersonBox/Transaction')
        },
        toVIP() {
            if (this.$route.path.indexOf('/vip') !== -1) {
                return
            }
            this.onNavToByIsLogin({ url: '/vip' })
        },
        toSetting() {
            if (this.$route.path.indexOf('/setting') !== -1) {
                this.$store.dispatch('user/setIsShowMyPopup', false)
                return
            }
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.onNavTo({ url: '/setting' })
        },
        onShowDownAppPopup() {
            this.$store.dispatch('user/setIsShowDownAppPopup', true)
        },
        toShare() {
            if (this.$route.path.indexOf('/affiliate') !== -1) {
                this.$store.dispatch('user/setIsShowMyPopup', false)
                return
            }
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.onNavTo({ url: '/affiliate' })
        },
        toServer() {
            this.onNavTo({ url: '/notification?type=0' })
        },
        toNotification() {
            this.onNavTo({ url: '/notification?type=1' })
        },
        toPerson() {
            // this.onNavTo({ url: '/personBox' })
            this.$router.push({ path: '/personBox' })
        },
        toRedemptionRecords() {
            this.$router.push('/PersonBox/RedemptionRecords')
        },
        toChangePwd() {
            this.$router.push('/PersonBox/ChangePwd')
        },
        toLanguage() {
            this.$router.push('/PersonBox/Language')
        },
        toDownApp() {
            this.$router.push('/PersonBox/DownApp')
        }
    },
    watch: {
        $route: {
            handler: function (to, from) {
                // this.act = ''
                // this.subAct = ''
                // const opt = this.$route?.params
                // if (opt && opt.params) {
                //     const params = JSON.parse(decodeURIComponent(opt?.params))
                //     this.act = params?.code
                //     if (params.gameTitleId) this.subAct = params.gameTitleId
                // }
                const meta = this.$route.meta
                this.isMobileHidePerson = meta.isMobileHidePerson
                this.menuAct = this.$route.name
            },
            deep: true,
            immediate: true
        }
        // classObj(newVal) {
        //     if (!newVal.mobile) {
        //         this.onPageRefresh()
        //     }
        // }
    }
}
</script>
<style lang="scss" scoped>
@import '@/common/styles/viriables.scss';

.pages {
    box-sizing: border-box;
    width: 92%;
    margin: .6rem auto .5rem auto;
    padding: .45rem .6rem .6rem .6rem;
    position: relative;
    background-image: var(--theme-common-frame-corner-top-left),
        /* 左上角 */
        var(--theme-common-frame-corner-top-right),
        /* 右上角 */
        var(--theme-common-frame-corner-bottom-left),
        /* 左下角 */
        var(--theme-common-frame-corner-bottom-right);
    /* 右下角 */

    /* 四个角位置 ↓ 一一对应 */
    background-position: left top,
        right top,
        left bottom,
        right bottom;

    /* 不重复 */
    background-repeat: no-repeat;

    /* 图片大小（根据你需求调整） */
    background-size: 2.25rem 1.5rem;

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        pointer-events: none;
        background-image:
            var(--theme-frame-line-vertical),
            var(--theme-frame-line-vertical);
        background-position: left center, right center;
        background-size: 0.04rem 100%, 0.04rem 100%;
        background-repeat: no-repeat;
    }

    &::after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        pointer-events: none;
        background-image:
            var(--theme-frame-line-horizontal),
            var(--theme-frame-line-horizontal);
        background-position: center top, center bottom;
        background-size: 100% 0.04rem, 100% 0.04rem;
        background-repeat: no-repeat;
    }

    &.mobile {
        // min-width: 100%;
        // height: 100vh;
        width: calc(100% - .1rem);
        padding: 0 .28rem;
        display: flex;
        flex-direction: column;
        margin: .08rem;
        padding-bottom: .38rem;

        &::after {
            background-size: 40% 0.04rem, 40% 0.04rem;
        }

        .van-nav-bar {
            display: none;
        }

        .user_info {
            width: 100%;

            .user_box {
                margin-bottom: 0;
                padding: .48rem 0;
                width: 100%;

                >img {
                    width: 1.3rem;
                    height: 1.3rem;
                    margin-right: .18rem;
                }

                >div {
                    padding-right: 0;
                    align-items: flex-start;

                    >div {
                        &.phone {
                            width: 100%;
                            margin-bottom: 0;
                            justify-content: space-between;
                            margin-top: -.08rem;

                            .phone-txt {
                                font-size: .3rem;
                                line-height: .4rem;
                            }

                            .reg-time {
                                display: none;
                            }
                        }

                        &.user_id {
                            height: .28rem;
                            line-height: .28rem;
                            font-size: .22rem;
                            margin-bottom: .18rem;

                            img {
                                width: .24rem;
                                height: .24rem;
                            }
                        }

                        &.totalData {
                            display: none;
                        }
                    }
                }
            }

            .user_btns {
                display: none;
            }
        }

        .main-content-wrap {
            padding: .3rem 0 .1rem 0;
            border-top: 0;
            padding-top: 0;

            .menus {
                display: none;
            }
        }

        &.isMobileHidePerson {
            padding: 0;
            background: transparent !important;
            box-sizing: border-box;
            height: 100vh;
            margin: 0;
            width: 100%;
            padding: 0 .18rem;
            padding-top: 1.2rem;

            .user_info {
                display: none;
            }

            .main-content-wrap {
                padding: 0;
                height: 100%;

                .main-content-box {
                    height: 100%;
                }
            }

            &::before {
                display: none;
            }

            &::after {
                display: none;
            }
        }
    }

    .van-nav-bar {
        background: transparent;

        .left_back {
            display: flex;
            align-items: center;
            font-size: .32rem;

            >img {
                width: 0.48rem;
                height: 0.48rem;
                margin-right: .24rem;
            }
        }
    }

    .user_info {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .user_box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            margin-bottom: .2rem;
            padding: .16rem .22rem;

            .icon_logout {
                width: .58rem;
                height: .58rem;
                border-radius: .02rem;
                position: relative;
                right: auto;
                top: auto;
                transform: none;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                flex: none;
                margin-left: .16rem;

                &>img {
                    width: .48rem;
                    height: .48rem;
                    vertical-align: middle;
                    filter: brightness(1.2) sepia(.18);
                }
            }

            >img {
                width: 1.5rem;
                height: 1.5rem;
                margin-right: .2rem;
            }

            >div {
                flex: 1;
                min-width: 0;
                padding-right: .16rem;
                display: flex;
                flex-direction: column;
                justify-content: center;

                >div {
                    &.phone {
                        margin-bottom: .02rem;
                        display: flex;
                        align-items: center;

                        .reg-time {
                            margin-left: .2rem;
                        }

                        .phone-txt {
                            font-size: .45rem;
                            line-height: .48rem;
                            color: var(--theme-bright-text);
                            font-weight: 700;
                        }
                    }

                    &.totalData {
                        display: flex;
                        align-items: center;
                        color: var(--theme-soft-text);
                        font-size: .26rem;

                        &>div {
                            display: flex;
                            align-items: flex-end;
                            margin-right: .38rem;

                            &>div:last-child {
                                color: var(--theme-bright-text);
                                font-size: .3rem;
                                margin-left: .08rem;
                            }
                        }
                    }

                    &.user_id {
                        height: .3rem;
                        line-height: .3rem;
                        color: var(--theme-soft-text);
                        font-size: .24rem;
                        display: flex;
                        align-items: center;
                        gap: .06rem;
                        text-align: left;
                        justify-content: flex-start;
                        margin-bottom: .1rem;

                        i {
                            cursor: pointer;
                            color: $font-person-accent-color;
                        }

                        img {
                            width: .26rem;
                            height: .26rem;
                            vertical-align: middle;
                        }
                    }
                }

                .reg-time {
                    width: auto;
                    display: inline-block;
                    border: .01rem solid var(--theme-surface-border);
                    border-radius: .06rem;
                    font-size: .22rem;
                    padding: .02rem .18rem;
                    margin: 0;
                    color: var(--theme-soft-text);
                }
            }
        }

        .user_btns {
            display: flex;
            justify-content: flex-end;

            &>div {
                width: 1.88rem;
                height: .68rem;
                border-radius: .12rem;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: .26rem;
                cursor: pointer;

                &:first-child {
                    background: $bg-btn-color;
                    color: $font-btn-color;
                    margin-right: .3rem;
                }

                &:last-child {
                    box-sizing: border-box;
                    border: .01rem solid transparent;
                    background-image:
                        linear-gradient(to right, var(--theme-popup-box-bg), var(--theme-popup-box-bg)),
                        linear-gradient(90deg, var(--theme-popup-box-border), var(--theme-popup-box-border));
                    background-origin: border-box;
                    background-clip: content-box, border-box;
                    box-shadow: var(--theme-popup-box-shadow);
                }
            }
        }
    }

    .main-content-wrap {
        width: 100%;
        border-top: 1px solid var(--theme-surface-border);
        position: relative;
        padding: .3rem 0 .1rem 290px;
        min-height: 500px;

        .menus {
            position: absolute;
            left: 0;
            top: .3rem;
            width: 270px;
            padding: .18rem .16rem;
            border-radius: .24rem;
            color: var(--theme-bright-text);
            font-size: .26rem;
            background: var(--theme-surface-bg);

            .menus-item {
                height: .78rem;
                line-height: .78rem;
                text-align: left;
                position: relative;
                background: rgba(0, 0, 0, 0.10);
                cursor: pointer;
                border-radius: .2rem;
                margin-bottom: .16rem;
                padding: 0 .18rem;

                &:last-child {
                    margin-bottom: 0;
                }

                &>i {
                    font-size: .44rem;
                    vertical-align: middle;
                    margin-right: .2rem;
                    color: $font-sub-color;
                }

                &:after {
                    content: '';
                    width: .17rem;
                    height: .17rem;
                    border-top: .02rem solid $font-title-color;
                    border-right: .02rem solid $font-title-color;
                    position: absolute;
                    right: .36rem;
                    top: calc(50% - .01rem);
                    transform: rotate(45deg) translateY(-50%);
                }

                &.menuAct {
                    background: var(--theme-active-bg);
                    color: var(--theme-active-text);
                }
            }
        }

        .main-content-box {
            width: 100%;
            min-height: 520px;
        }
    }
}</style>

<style lang="scss" scoped>
.profile-console {
    width: calc(100% - 32px);
    max-width: 1500px;
    margin: 16px auto 48px;
    padding: 0;
    background: transparent;
    color: var(--theme-bright-text);
    font-family: "Segoe UI", Arial, sans-serif;

    &::before,
    &::after { display: none; }
}

.profile-identity {
    min-height: 126px;
    display: grid;
    grid-template-columns: minmax(280px, 1.3fr) minmax(180px, .85fr) minmax(150px, .7fr) minmax(150px, .7fr) 52px;
    align-items: center;
    gap: 28px;
    padding: 18px 24px;
    border: 1px solid var(--theme-divider);
    border-bottom-color: rgba(var(--theme-input-focus-border-rgb), .42);
    border-radius: 5px 5px 0 0;
    background: linear-gradient(100deg, #202124, #17181a 62%, #1d1d20);
    box-shadow: inset 0 1px rgba(255, 255, 255, .04);
}

.identity-user { display: flex; align-items: center; min-width: 0; }

.avatar-wrap {
    width: 84px;
    height: 84px;
    flex: 0 0 84px;
    position: relative;
    margin-right: 18px;

    img {
        width: 100%;
        height: 100%;
        display: block;
        border: 2px solid #dda17f;
        border-radius: 50%;
        object-fit: cover;
        background: #292a2d;
    }

    span {
        position: absolute;
        left: 50%;
        bottom: -7px;
        transform: translateX(-50%);
        min-width: 48px;
        padding: 3px 7px;
        border: 1px solid #b8754f;
        border-radius: 3px;
        background: #191a1c;
        color: #f3bd55;
        font-size: 10px;
        font-weight: 800;
        text-align: center;
        white-space: nowrap;
    }
}

.identity-copy {
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    > strong {
        max-width: 100%;
        overflow: hidden;
        color: #fff;
        font-size: 23px;
        line-height: 1.2;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    button {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        margin-top: 10px;
        padding: 5px 8px;
        border: 0;
        border-radius: 3px;
        background: #2a2b2e;
        color: var(--theme-soft-text);
        font-size: 12px;
        cursor: pointer;

        svg { font-size: 15px; }
    }
}

.identity-meta,
.identity-stat {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;

    span { color: #8f9297; font-size: 12px; }
    strong { overflow-wrap: anywhere; color: #f2eeeb; font-size: 15px; font-weight: 600; }
}

.identity-stat strong { color: #f3bd55; font-size: 20px; }

.identity-logout {
    width: 44px;
    height: 44px;
    display: grid;
    place-items: center;
    border: 1px solid rgba(244, 73, 61, .6);
    border-radius: 4px;
    background: transparent;
    color: var(--theme-signin-progress-line);
    cursor: pointer;

    svg { font-size: 24px; }
}

.profile-layout {
    display: grid;
    grid-template-columns: 250px minmax(0, 1fr);
    border: 1px solid var(--theme-divider);
    border-top: 0;
    background: #121315;
}

.profile-nav {
    min-height: 700px;
    display: flex;
    flex-direction: column;
    padding: 14px 12px;
    border-right: 1px solid var(--theme-divider);
    background: linear-gradient(180deg, #1d1f21, #17181a);

    > button {
        width: 100%;
        min-height: 50px;
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 0 14px;
        border: 0;
        border-left: 3px solid transparent;
        border-radius: 2px;
        background: transparent;
        color: #d1cdca;
        font-size: 14px;
        text-align: left;
        cursor: pointer;
        transition: background .18s, color .18s, border-color .18s;

        svg { flex: 0 0 21px; font-size: 21px; color: #a7a8ab; }

        &:hover { background: rgba(255, 255, 255, .035); color: #fff; }
        &.active {
            border-left-color: var(--theme-signin-progress-line);
            background: linear-gradient(90deg, rgba(244, 73, 61, .2), rgba(244, 73, 61, .03));
            color: #ff766b;

            svg { color: #ff766b; }
        }
    }

    .nav-separator { height: 1px; margin: 10px 12px; background: var(--theme-divider); }
    .nav-logout { margin-top: auto; border: 1px solid rgba(244, 73, 61, .42); color: #ff766b; }
}

.profile-workspace { min-width: 0; padding: 18px; }

.profile-subpage-back {
    min-height: 44px;
    display: inline-flex;
    align-items: center;
    gap: 9px;
    margin: 0 0 12px;
    padding: 0 16px;
    border: 1px solid var(--theme-divider);
    border-radius: 3px;
    background: #232528;
    color: #e8e3df;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: border-color .18s, background .18s, color .18s;

    svg {
        width: 20px;
        height: 20px;
    }

    &:hover {
        border-color: var(--theme-signin-progress-line);
        background: rgba(244, 73, 61, .12);
        color: var(--theme-signin-progress-line);
    }
}

.profile-console.isMobileHidePerson {
    width: 100%;
    height: 100vh;
    margin: 0;
    padding: 1.2rem .18rem 0;

    .profile-layout { display: block; border: 0; background: transparent; }
    .profile-workspace { height: 100%; padding: 0; }
}

@media screen and (min-width: 768px) {
    .profile-console.isMobileHidePerson {
        height: auto;
        padding: 22px;

        .profile-workspace {
            height: auto;
        }
    }
}

@media screen and (max-width: 1100px) and (min-width: 768px) {
    .profile-identity { grid-template-columns: minmax(250px, 1.2fr) minmax(150px, .8fr) 140px 140px 44px; gap: 14px; padding: 16px; }
    .profile-layout { grid-template-columns: 210px minmax(0, 1fr); }
    .profile-nav > button { padding: 0 10px; gap: 10px; font-size: 12px; }
}

@media screen and (max-width: 767px) {
    .profile-console.mobile {
        width: 100%;
        margin: 0 0 84px;
        padding: 0 10px;
    }

    .profile-identity {
        min-height: 118px;
        grid-template-columns: minmax(0, 1fr) 42px;
        gap: 8px;
        padding: 14px 12px 16px;
        border-radius: 0;
    }

    .avatar-wrap { width: 70px; height: 70px; flex-basis: 70px; margin-right: 13px; }
    .identity-copy > strong { font-size: 19px; }
    .identity-copy button { margin-top: 7px; }
    .identity-meta { grid-column: 1 / -1; margin-left: 83px; margin-top: -29px; gap: 2px; }
    .identity-meta span { display: none; }
    .identity-meta strong { color: #92959a; font-size: 10px; font-weight: 500; }
    .identity-stat { display: none; }
    .identity-logout { grid-column: 2; grid-row: 1; width: 40px; height: 40px; }
    .profile-layout { display: block; border: 0; background: transparent; }
    .profile-workspace { padding: 10px 0 0; }
}
</style>

<style lang="scss">
@import '@/common/styles/person-center.scss';
</style>
